import { decodeBase64 } from '../conversion/decodeBase64';
import { consoleLogger } from '../logging/consoleLogger';
import { createCookie } from './createCookie';
import { readCookie } from './readCookie';

export const getValidatedBase64Cookie = (documentCookie, name) => {
  try {
    const cookieValue = readCookie(documentCookie, name);
    return decodeBase64(cookieValue);
  } catch (err) {
    if (err instanceof DOMException && err.name === 'InvalidCharacterError') {
      consoleLogger.logInfo(`Invalid cookie "${name}" is being cleared...`);
      document.cookie = createCookie({
        name,
        value: 'none',
        days: 0,
      });
      consoleLogger.logInfo(`Cookie "${name}" has been cleared.`);
      return '';
    }
    throw err;
  }
};
